module.exports = __webpack_public_path__ + "static/media/1.b4e6f4d7.svg";